import { ExpandIcon } from '#assets/ReactSvg.ts';
import { IconButton } from '#components/atoms/buttons/icon/icon-button/IconButton.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';

type Props = {
  onClick: () => void;
};

export function ExpandButton({ onClick }: Props) {
  return (
    <Tooltip
      content="Expand commands"
      placement="left"
      render={
        <IconButton title="Expand commands" onClick={onClick}>
          <ExpandIcon />
        </IconButton>
      }
    />
  );
}
